<template>
  <v-layout column class="pagemargin page">
    <!--Toolbar for buttons-->
    <v-toolbar class="secondary">
      <vupload
        apikey="A9Qx1trOUQuO4jYrB95b2z"
        path:folderPath
        v-bind:accept="['application/pdf', 'image/*', 'video/*']"
        v-bind:security="{
        policy:
          'eyJjYWxsIjpbInBpY2siLCJyZWFkIiwid3JpdGUiLCJzdG9yZSJdLCJleHBpcnkiOjE5MjQ5OTIwMDB9',
        signature:
          'e0cfd5fd0fc1aeb84a0d4d34fd6bf593c139a8a0741989e8aa5a1eab5c6135d2'
      }"
        label="Upload"
        classes="secondary v-btn white--text"
        v-on:result="uploadResult = $event"
      ></vupload>
      <v-btn class="primary" @click="dialog = true">Popup</v-btn>
    </v-toolbar>
    <!--/Toolbar for buttons-->

    <!--Dialog part-->
    <v-dialog
      v-model="dialog"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">

      <!--Toolbar-->
      <v-toolbar color="grey darken-1" dark>
        <v-toolbar-title v-for="file in files[0]" v-bind:key="file.uploadId">{{file.filename}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon>
          <v-icon @click="dialog = false">close</v-icon>
        </v-btn>
      </v-toolbar>

      <!--Embedded file-->
      <v-card v-for="file in files[0]" v-bind:key="file.uploadId">
        <vdownload
          url="https://cdn.filestackcontent.com/"
          apikey="A9Qx1trOUQuO4jYrB95b2z"
          policy="eyJjYWxsIjpbInBpY2siLCJyZWFkIiwid3JpdGUiLCJzdG9yZSJdLCJleHBpcnkiOjE5MjQ5OTIwMDB9"
          signature="e0cfd5fd0fc1aeb84a0d4d34fd6bf593c139a8a0741989e8aa5a1eab5c6135d2"
          :handle="file.handle"
          width="100%"
          height="700"
          tag="iframe"
          :v-bind:embed="true"
          classes="red white--text"
        ></vdownload>
      </v-card>
    </v-dialog>
    <!-- /Dialog part -->

    <!--Result table-->
    <v-card>
    <table>
      <tr>
        <td>FileName</td>
        <td>URL</td>
      </tr>
      <tr v-for="file in files[0]" v-bind:key="file.uploadId">
        <td>{{ file.filename }}</td>
        <td>
          <vdownload
            url="https://cdn.filestackcontent.com/"
            apikey="A9Qx1trOUQuO4jYrB95b2z"
            policy="eyJjYWxsIjpbInBpY2siLCJyZWFkIiwid3JpdGUiLCJzdG9yZSJdLCJleHBpcnkiOjE5MjQ5OTIwMDB9"
            signature="e0cfd5fd0fc1aeb84a0d4d34fd6bf593c139a8a0741989e8aa5a1eab5c6135d2"
            :handle="file.handle"
            :v-bind:width="300"
            :v-bind:height="500"
            tag="iframe"
            :v-bind:embed="true"
            classes="red white--text"
          >{{ file.filename }}</vdownload>
          <a :href="CreateURL(file.handle)">{{ file.filename }}</a>
        </td>
      </tr>
    </table>
    </v-card>
    <!-- /Dialog part-->


    <!--JSON result part
    <v-container grid-list-md text-center>
      <v-layout wrap>
        <v-flex xs6>
          <v-card>
            <v-card-text class="px-0">Result</v-card-text>
            <pre align="left"><code>{{ uploadResult }}</code></pre>
          </v-card>
        </v-flex>
        <v-flex xs6>
          <v-card>
            <v-card-text class="px-0">Files collection</v-card-text>
            <pre align="left"><code>{{ files }}</code></pre>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
     /JSON result part-->
  </v-layout>
</template>

<script>
import { mapState } from "vuex";
import vupload from "@/components/filestack/vupload.vue";
import vdownload from "@/components/filestack/vdownload.vue";

export default {
  components: {
    vupload,
    vdownload
  },
  data: () => ({
    dialog: false,
    folderPath:  null,
    uploadResult: "Nothing",
    files: [],
    apikey: "A9Qx1trOUQuO4jYrB95b2z",
    downloadurl: "https://cdn.filestackcontent.com/",
    output: "",
    readpolicy:
      "eyJjYWxsIjpbInBpY2siLCJyZWFkIiwid3JpdGUiLCJzdG9yZSJdLCJleHBpcnkiOjE5MjQ5OTIwMDB9",
    readsignature:
      "e0cfd5fd0fc1aeb84a0d4d34fd6bf593c139a8a0741989e8aa5a1eab5c6135d2"
  }),
  computed: {
    ...mapState({
      portal: state => state.portal
    }),
    definePath() {
      this.folderPath = "/" + this.portal.active.id + "/";
      // console.log("FOLDER paaath: " + this.folderPath);
      return this.folderPath;
    }
  },
  mounted() {
        this.folderPath = "/" + this.portal.active.id + "/sponsors/";

      // console.log(" mounted path: " + this.folderPath);
    // console.log("portal domain: " + this.portal.active.domainURL);
  },
  watch: {
    uploadResult() {
      this.files.push(this.uploadResult);
      //console.log("handle: " + JSON.stringify(this.uploadResult, null, 2));
      // // console.log("test: " + this.uploadResult[0].key);
      //console.log("files: " + JSON.stringify(this.files, null, 2));
      //console.log("files[0]: " + JSON.stringify(this.files[0], null, 2));
    }
  },
  methods: {
    CreateURL(handle) {
      return (
        this.downloadurl +
        //this.uploadResult[0].key
        this.apikey +
        this.output +
        "/security=policy:" +
        this.readpolicy +
        ",signature:" +
        this.readsignature +
        "/" +
        handle
      );
      //console.log("handle: " + handle);
    }
  }
};
</script>

<style>
</style>
